export default {
  IS_EMAIL: /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
  IS_PHONE: /^(\(\+20\) )?01([0-2]|5)[0-9]{8}$/,
  HTML_TAGS: /<\/?[^>]+(>|$)/g,
  HTML_TAGS_EXCEPT_MEDIA: /(<\s*a[^>]*>)|(<[^>|img]*>)|(&nbsp;)/gi,
  HTML_TAGS_WITH_SPACES: /(<\s*a[^>]*>)|(<[^>]*>)|([\s]{1,}|&nbsp;)/gi,
  EMPTY_EDITOR_CONTENT: /^<p[^>]*>((<br *>)|[ \n\r\t])*<\/p>$/,
  isNumber: /^\d+$/,
  EQUATION: /<span class="ql-formula" (.|\n)*?<\/span><\/span>.<\/span>/g,
  IMAGE: /<img[^>]+>/i
};